import { defineMessages } from 'react-intl'

export default defineMessages({
  name: {
    id: 'components.Captcha.name',
    defaultMessage: 'Authentication Code',
    description: '请修改',
  }
})
